import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from "@angular/core";
import { MainState } from "@app/store/state";
import { UserProfileInterface } from "@core/interfaces/user-profile.interface";
import { UserInterface } from "@core/interfaces/user.interface";
import { DeviceService } from "@core/services/device.service";
import { ScrollHideService } from "@core/services/scroll-hide.service";
import { UserService } from "@core/services/user.service";
import { Store } from "@ngrx/store";
import { BaseComponentDirective } from "@shared/components/base-component.directive";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "astrobin-mobile-footer",
  templateUrl: "./mobile-footer.component.html",
  styleUrls: ["./mobile-footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileFooterComponent extends BaseComponentDirective implements OnInit {
  @HostBinding("class.footer-hidden") isFooterHidden = false;
  @HostBinding("class.d-none") isFooterDisabled = false;

  user: UserInterface;
  userProfile: UserProfileInterface;
  isPwaMode$: Observable<boolean>;

  constructor(
    public readonly store$: Store<MainState>,
    private readonly scrollHideService: ScrollHideService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public readonly userService: UserService,
    private deviceService: DeviceService
  ) {
    super(store$);
    this.isPwaMode$ = this.deviceService.isPwaMode$;
  }

  ngOnInit() {
    super.ngOnInit();

    // Subscribe to footer visibility changes from the service
    this.scrollHideService
      .getFooterVisibility()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(isHidden => {
        this.isFooterHidden = isHidden;
        this.changeDetectorRef.markForCheck();
      });

    // Get current user data
    this.currentUserWrapper$.pipe(takeUntil(this.destroyed$)).subscribe(wrapper => {
      this.user = wrapper.user;
      this.userProfile = wrapper.userProfile;
      this.changeDetectorRef.markForCheck();
    });

    // Show footer only in PWA mode
    this.isPwaMode$.pipe(takeUntil(this.destroyed$)).subscribe(isPwa => {
      this.isFooterDisabled = !isPwa;
      this.changeDetectorRef.markForCheck();
    });
  }

  openUserGallery(): void {
    if (this.user) {
      this.userService.openGallery(this.user.username, this.userProfile?.enableNewGalleryExperience);
    }
  }
}
